class IRFaqs extends HTMLElement {
  constructor() {
    super();
    this.faqs = this.querySelectorAll('details');
    this.summaries = this.querySelectorAll('summary');
    
    // Bind click listeners
    this.summaries.forEach((summary) => {
      summary.addEventListener('click', (e) => this.toggleFaq(e, summary));
    });

    // Initialize content wrapper styles for JS-enabled slide animation
    this.faqs.forEach((details) => {
      const content = details.querySelector('.ir-faq-content-wrapper');
      if (content) {
        content.style.overflow = 'hidden';
        if (!details.hasAttribute('open')) {
          content.style.height = '0px';
        } else {
          content.style.height = 'auto'; 
        }
      }
    });
  }

  toggleFaq(e, summary) {
    e.preventDefault(); // Stop native instant opening/closing
    const details = summary.parentElement;
    
    // Prevent clicking while animation is running
    if (details.dataset.animating === 'true') {
      return; 
    }

    const isOpen = details.hasAttribute('open');

    // Enforce "open only one at a time"
    if (!isOpen) { 
      // If we are opening this one, close any other open FAQ first
      this.faqs.forEach((otherDetails) => {
        if (otherDetails !== details && otherDetails.hasAttribute('open')) {
          this.closeFaq(otherDetails);
        }
      });
      // Then open the clicked one
      this.openFaq(details);
    } else {
      // If it's already open, just close it
      this.closeFaq(details);
    }
  }

  openFaq(details) {
    const content = details.querySelector('.ir-faq-content-wrapper');
    if (!content) return;

    details.dataset.animating = 'true';
    details.setAttribute('open', ''); // Start rendering content so we can get its height

    // Measure how tall the content needs to be
    const targetHeight = content.scrollHeight;
    
    // Animate from 0 to target height
    content.style.height = '0px';
    content.offsetHeight; // Force browser to reflow
    content.style.transition = 'height 0.3s ease-in-out';
    content.style.height = targetHeight + 'px';

    const onTransitionEnd = () => {
      content.removeEventListener('transitionend', onTransitionEnd);
      content.style.height = 'auto'; // Reset to auto to support responsive resizing
      content.style.transition = '';
      details.dataset.animating = 'false';
    };

    content.addEventListener('transitionend', onTransitionEnd);
  }

  closeFaq(details) {
    const content = details.querySelector('.ir-faq-content-wrapper');
    if (!content) return;

    details.dataset.animating = 'true';

    // Lock current height from auto to exact pixels before animating to 0
    const startHeight = content.scrollHeight;
    content.style.height = startHeight + 'px';
    content.offsetHeight; // Force browser to reflow
    
    // Animate to 0
    content.style.transition = 'height 0.3s ease-in-out';
    content.style.height = '0px';

    const onTransitionEnd = () => {
      content.removeEventListener('transitionend', onTransitionEnd);
      details.removeAttribute('open'); // Now finally hide the native details
      content.style.transition = '';
      details.dataset.animating = 'false';
    };

    content.addEventListener('transitionend', onTransitionEnd);
  }
}

if (!customElements.get('ir-faqs')) {
  customElements.define('ir-faqs', IRFaqs);
}
